<template lang="pug">
label.label(v-if="label" :for="name") {{label}}
FormField(v-slot="$field" :name="name")
  InputNumber(
    v-model="$field.value"
    :inputId="$attrs.id || name"
    :inputClass="inputCssClasses"
    prefix="$ "
    :minFractionDigits="$attrs.minFractionDigits || 2"
    :fluid="$attrs.fluid==false ? false : true"
  )
  Message(v-if="$field?.invalid && ($field?.touched || formSubmitted)" severity="error" size="small" variant="simple") {{ $field.error?.message }}
</template>

<script setup>
import { computed, inject, ref, useAttrs } from 'vue'
import InputNumber from "primevue/inputnumber"
import { FormField } from '@primevue/forms'
import Message from 'primevue/message'

const formSubmitted = inject('appFormSubmitted', ref(false))

defineOptions({inheritAttrs: false})

const props = defineProps({
  name:   { type: String, required: true },
  label:  { type: String, required: false },
})

const attrs = useAttrs()

const inputCssClasses = computed(() => {
  return [attrs.class, 'text-right'].join(' ')
})
</script>